import axiosInstance from "./axiosInstance";

export const getNotifications = async (limit = 50) => {
  const response = await axiosInstance.get("/notifications", {
    params: { limit },
  });
  return response.data;
};

export const markNotificationAsRead = async (notificationId) => {
  const response = await axiosInstance.put(`/notifications/${notificationId}/read`);
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const response = await axiosInstance.put("/notifications/mark-all-read");
  return response.data;
};

export const deleteNotificationById = async (notificationId) => {
  const response = await axiosInstance.delete(`/notifications/${notificationId}`);
  return response.data;
};

export const getBulkUploadDetails = async (notificationId) => {
  const response = await axiosInstance.get(
    `/notifications/${notificationId}/details`,
  );
  return response.data.details;
};
